module.exports = __webpack_public_path__ + "img/whiteRose-1.d86133e0.jpg";